import { useState, useRef, useCallback } from "react";
import { FaChevronDown } from "react-icons/fa";
import PortalDropdown from "./PortalDropdown";

const TableNameFilter = ({ tables, selectedTableNameFilter, setSelectedTableNameFilter, setRsvpFilter, setTableFilter }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const handleClose = useCallback(() => setOpen(false), []);

    return (
        <div ref={anchorRef}>
            <button
                onClick={() => setOpen(o => !o)}
                className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-all whitespace-nowrap flex items-center gap-1 ${selectedTableNameFilter
                    ? 'bg-gray-800 text-white border-gray-800'
                    : 'bg-white text-gray-600 border-gray-300 hover:border-gray-400'
                    }`}
            >
                {selectedTableNameFilter ? <span className="capitalize">{selectedTableNameFilter}</span> : 'Po stolu'}
                <FaChevronDown className={`text-xs transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>
            <PortalDropdown anchorRef={anchorRef} open={open} onClose={handleClose}>
                <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden min-w-[160px]">
                    <button
                        onMouseDown={() => { setSelectedTableNameFilter(''); setOpen(false); }}
                        className="w-full px-4 py-2.5 text-sm text-left text-gray-500 hover:bg-gray-50 border-b"
                    >
                        Svi stolovi
                    </button>
                    {tables.map(table => (
                        <button
                            key={table._id}
                            onMouseDown={() => {
                                setSelectedTableNameFilter(table.name);
                                setRsvpFilter('all');
                                setTableFilter('all');
                                setOpen(false);
                            }}
                            className={`w-full px-4 py-2.5 text-sm text-left capitalize hover:bg-rose-50 transition ${selectedTableNameFilter === table.name ? 'font-semibold text-rose-600 bg-rose-50' : 'text-gray-700'}`}
                        >
                            {table.name}
                        </button>
                    ))}
                </div>
            </PortalDropdown>
        </div>
    );
};

export default TableNameFilter;
